import React from 'react';

import { useFormikContext } from 'formik';

import Input from 'components/shared/Input/Input';

const ExportInputTitle = () => {
  const { values, handleChange, errors } = useFormikContext();

  return (
    <Input
      required
      name="title"
      label="Export as"
      value={values.title}
      onChange={handleChange}
      error={errors.title}
      placeholder="Write file name"
    />
  );
};

export default ExportInputTitle;
